import {
  Brain,
  CalendarDays,
  Globe,
  HardDrive,
  Mail,
  Search,
  Terminal,
  Wrench,
  type LucideIcon,
} from 'lucide-react'

export interface ToolVisual {
  key: string
  label: string
  Icon: LucideIcon
  accentClass: string
}

const TOOL_VISUALS: Record<string, ToolVisual> = {
  web_search: {
    key: 'web_search',
    label: 'Web Search',
    Icon: Globe,
    accentClass: 'text-emerald-300',
  },
  gmail: {
    key: 'gmail',
    label: 'Gmail',
    Icon: Mail,
    accentClass: 'text-rose-300',
  },
  calendar: {
    key: 'calendar',
    label: 'Calendar',
    Icon: CalendarDays,
    accentClass: 'text-sky-300',
  },
  drive: {
    key: 'drive',
    label: 'Drive',
    Icon: HardDrive,
    accentClass: 'text-lime-300',
  },
  memory: {
    key: 'memory',
    label: 'Memory',
    Icon: Brain,
    accentClass: 'text-fuchsia-300',
  },
  code_runner: {
    key: 'code_runner',
    label: 'Code Runner',
    Icon: Terminal,
    accentClass: 'text-violet-300',
  },
  search: {
    key: 'search',
    label: 'Search',
    Icon: Search,
    accentClass: 'text-cyan-300',
  },
  unknown: {
    key: 'unknown',
    label: 'Tool',
    Icon: Wrench,
    accentClass: 'text-slate-300',
  },
}

function normalizeToolName(toolName: string): string {
  return toolName.trim().toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_')
}

export function getToolVisual(toolName: string): ToolVisual {
  const normalized = normalizeToolName(toolName)

  if (normalized in TOOL_VISUALS) {
    return TOOL_VISUALS[normalized]
  }

  if (normalized.includes('web') && normalized.includes('search')) return TOOL_VISUALS.web_search
  if (normalized.includes('gmail') || normalized.includes('mail')) return TOOL_VISUALS.gmail
  if (normalized.includes('calendar')) return TOOL_VISUALS.calendar
  if (normalized.includes('drive') || normalized.includes('storage')) return TOOL_VISUALS.drive
  if (normalized.includes('memory') || normalized.includes('brain')) return TOOL_VISUALS.memory
  if (normalized.includes('code') || normalized.includes('runner')) return TOOL_VISUALS.code_runner
  if (normalized.includes('search')) return TOOL_VISUALS.search

  return {
    ...TOOL_VISUALS.unknown,
    label: prettifyToolName(toolName),
  }
}

export function prettifyToolName(toolName: string): string {
  const raw = normalizeToolName(toolName).replace(/_/g, ' ').trim()
  if (!raw) return 'Tool'
  return raw.replace(/\b\w/g, (match) => match.toUpperCase())
}
